import React, { createContext, useState, ReactNode } from 'react'

interface NotificationContextProps {
  notification: string | null
  showNotification: (message: string) => void
  hideNotification: () => void
}

export const NotificationContext = createContext<NotificationContextProps>({
  notification: null,
  showNotification: () => {},
  hideNotification: () => {},
})

interface INotificationProviderProps {
  children: ReactNode
}

export const NotificationProvider: React.FC<INotificationProviderProps> = ({
  children,
}) => {
  const [notification, setNotification] = useState<string | null>(null);

  const showNotification = (message: string) => {
    setNotification(message)
  }

  const hideNotification = () => {
    setNotification(null)
  }

  return (
    <NotificationContext.Provider
      value={{ notification, showNotification, hideNotification }}
    >
      {children}
    </NotificationContext.Provider>
  )
}